module.exports = __webpack_public_path__ + "static/media/10.ed1e6335.png";